const lang = {
  page_title: '契約団体',
  breadcrumb: {
    list: '契約団体',
    detail: '契約団体詳細',
  },
  button: {
    add: '＋団体を登録する',
    show_expired_organization: '契約終了した団体も表示する',
    delete: '削除',
    add_account: '＋アカウント追加',
  },
  table: {
    name: '団体名',
    ended_at: '契約終了日',
    user_count: 'ユーザー数',
    registered_project_count: '登録済プロジェクト数',
    certified_project_count: '終了プロジェクト数',
    delete: '削除',
  },
  detail: {
    head: {
      memo: '説明',
      contract_period: '契約期間',
      account: 'アカウント',
    },
    content: {
      contract_start: '契約開始：',
      contract_end: '契約終了：',
      delete_organization: '契約団体を削除する',
      no_data: '登録情報がありません。',
    },
  },
  create_modal: {
    title: '契約団体の追加',
    name: '団体名',
    placeholder: {
      name: '団体名を入力',
      memo: '説明を入力...',
    },
  },
  edit_modal: {
    title: '契約団体の編集',
    name: '団体名',
    placeholder: {
      name: '団体名を入力',
      memo: '説明を入力...',
    },
  },
  create_member_modal: {
    title: 'アカウントの追加',
    name: 'アカウント名',
    email: 'メールアドレス',
    placeholder: {
      name: 'アカウント名を入力',
      email: 'メールアドレスを入力',
    },
  },
  delete_member_modal: {
    title: 'アカウントの削除',
    explain:
      'アカウントを削除すると、アカウント利用者は再びFCSにログインできなくなります。アカウント利用者の承認を得てから、削除を行なってください。',
  },
  delete_modal: {
    title: '契約団体の削除',
    explain:
      '削除した団体のデータは再び参照できません。団体に関係する利用者がいないことを確認してから削除を行なってください。',
    errors: {
      members: 'アカウントが登録されているため削除できません。',
      ended_at: '契約期間が終了していません。',
    },
  },
  common_model: {
    errors: {
      required_name: '団体名は必須です。',
      limit_name: '団体名は50文字以内で入力してください。',
      limit_memo: '説明は200文字以内で入力してください。',
      required_endedAt: '契約終了は必須です。',
    },
  },
}

export default lang
